import angular from 'angular';

module.exports = angular.module('common.components.od-flip-dates-container', [
  require('common/services/flip-dates')
])
.component('odFlipDatesContainer', {
  transclude: true,
  bindings: {
    flipId: '<',
    format: '<',
  },
  template: require('./od-flip-dates-container.jade')(),
  controller: class {
    constructor(FlipDates) {
      this.FlipDates = FlipDates;
      this.isLoaded = false;
    }

    $onChanges(changes) {
      let { currentValue, previousValue } = changes.flipId;
      if (currentValue && currentValue !== previousValue) {
        this.isLoaded = false;

        this.FlipDates.fetchDates(currentValue).then((flipDates) => {
          this.flipDates = flipDates;
          this.isLoaded = true;
        });
      }
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/od-flip-dates-container.js
 **/